exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".heart{z-index:3;height:32px;position:absolute;right:8px;top:8px;cursor:pointer;font-size:32px;color:#fff;line-height:32px}.heart.active{color:#f23d4e}.heart.left-align{right:auto;left:8px}", ""]);

